import React from 'react';
import { PanelContainer } from '../Panel/Panel.styled';

const IntegrationPanel = () => (
  <PanelContainer id="integration">
    <div>
      <h2>Integration</h2>
      <p>Easy embed into any platform.</p>
      {/* Add unique content and layout for Integration */}
    </div>
  </PanelContainer>
);

export default IntegrationPanel;
